import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

export interface authenticateLayout {
  isAuthenticated : boolean;
}


export interface storeUserLayout {
  isStoreUser : boolean;
}

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private token: string;
  private userId: string;
  private tokenTime: string;
  public authenticatedSubject = new Subject<authenticateLayout>();
  public storeUserSubject = new Subject<storeUserLayout>();


  constructor() {
    this.token = this.getToken();
    this.userId = this.getUserId();
    this.tokenTime = this.getTokenTime();
  }

  public getToken(): string {
    if (localStorage.getItem('id_token') != null) {
      return localStorage.getItem('id_token');
    }
    return null;
  }

  getAuthentication() : Observable<any> {
    return this.authenticatedSubject.asObservable();
  }

  updateAuthentication(isAuthenticated: boolean) {
      this.authenticatedSubject.next({isAuthenticated: isAuthenticated});
  }

  getStoreUser() : Observable<any> {
    return this.storeUserSubject.asObservable();
  }

  updateStoreUser(isAuthenticated: boolean) {
      this.storeUserSubject.next({isStoreUser: isAuthenticated});
  }

  public setToken(token, id) {
    this.token = token;
    this.userId = id;
    localStorage.setItem('id_token', token);
    localStorage.setItem('id', id);
    localStorage.setItem('time', String(new Date()));
  }
  public IsLoggedIn(): boolean {
    if (localStorage.getItem('id_token') != null) {
      return true;
    }
    return false;
  }
  public getUserId() {
    if (localStorage.getItem('id') != null) {
      return localStorage.getItem('id');
    }
    return null;
  }

  public getTokenTime() {
    if (localStorage.getItem('time') != null) {
      return localStorage.getItem('time');
    }
    return null;
  }

  resetTokens() {
    this.token = null;
    this.userId = null;
    this.tokenTime = null;
    localStorage.clear();
  }
}
